// Centralized constants — replace magic numbers throughout the app.

// File uploads
export const MAX_CV_FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB
export const KILOBYTE = 1024;

// Exit-intent popup
export const EXIT_INTENT_DELAY_MS = 30_000; // 30s before showing time-based fallback

// CMS / Edit mode
export const TOAST_QUICK_DURATION_MS = 1200;
